import { render } from "./ContractsSeriesView.vue?vue&type=template&id=c96dd37a"
import script from "./ContractsSeriesView.vue?vue&type=script&lang=js"
export * from "./ContractsSeriesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/view/ContractsSeriesView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c96dd37a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c96dd37a', __exports__)) {
    api.reload('c96dd37a', __exports__)
  }
  
  module.hot.accept("./ContractsSeriesView.vue?vue&type=template&id=c96dd37a", () => {
    api.rerender('c96dd37a', render)
  })

}


export default __exports__